// extracted by mini-css-extract-plugin
module.exports = {"root":"AspectRatio_root__OIjqZ","inner":"AspectRatio_inner__LgNSQ"};